export class UserData {
}
export class queues {
  queueNameList: Array<{name: string}> = []; 
}
